/* eslint-disable consistent-return */
import { apiSendReferalEmail } from "Root/api/apiProfile";
import toastService from "Root/profile/toastService";
import { setGlobalLoading, setHasShared } from "../../actionCreators/makeActionCreator";
export const SendReferalEmailThunk = (body) => async (dispatch) => {
    try {
        dispatch(setGlobalLoading(true));
        const result = await apiSendReferalEmail(body);
        dispatch(setGlobalLoading(false));
        if ("msg" in result) {
            const { msg } = result;
            if (msg === "success") {
                dispatch(setHasShared(true));
                toastService.successMessage("Success!");
            }
            else if (msg === "error") {
                toastService.errorMessage("Something went wrong, please try again");
            }
            else {
                toastService.errorMessage(msg, 7000);
            }
        }
        else {
            toastService.errorMessage("Something went wrong, please try again");
        }
        return result;
    }
    catch (error) {
        toastService.errorMessage("Something went wrong");
    }
};
export default SendReferalEmailThunk;
